import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeviceLogsRoutingModule } from './device-logs-routing.module';
import { DeviceLogsComponent } from './device-logs/device-logs.component';
import { FiltersModule } from 'libs/portal/src/modules/tools/filters/filters.module';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { FormsModule } from '@angular/forms';
import { TimeAgoExtendsPipe } from 'libs/portal/src/modules/tools/pipes/time-ago.pipe';
import { LocationRadiusModalModule } from '../../components/location-radius-modal/location-radius-modal.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatRowComponent } from '../../../tools/mat-row/mat-row.component';

@NgModule({
  declarations: [DeviceLogsComponent],
  imports: [CommonModule, FormsModule, CardTableModule, FiltersModule, DeviceLogsRoutingModule, LocationRadiusModalModule, MaterialModule, MatRowComponent],
  providers: [TimeAgoExtendsPipe],
})
export class DeviceLogsModule {}
